import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: {
        loggedIn: false,
        data: null
      },
    handles: [ 'starbucks', 'java joe\'s'], // Store the user's handles
    events: [
      { id: 1, title: '...', organizer: '...' },
      { id: 2, title: '...', organizer: '...' },
      { id: 3, title: '...', organizer: '...' },
      { id: 4, title: '...', organizer: '...' }
    ]
  },
  mutations: {
    SET_LOGGED_IN(state, value) {
        state.user.loggedIn = value;
      },
    SET_USER(state, data) {
      state.user.data = data;
    }
  },
  actions: {
    fetchUser({ commit }, user) {
        commit("SET_LOGGED_IN", user !== null);
        if (user) {
          commit("SET_USER", {
            displayName: user.displayName,
            email: user.email,
            uid: user.uid
          });
        } else {
          commit("SET_USER", null);
        }
    }
  },
  getters: {
    user(state){
        return state.user
    },
    getEventById: state => id => {
      return state.events.find(event => event.id === id)
    }
  }
})
